import angular from "angular";
import _ from "lodash";

import BaseAddModal from "app/common/create.modal";
import { BaseReCalc } from "app/common/calculation";
import BaseNotesCtrl from "app/common/notes.ctrl";

import { MARION_ID, roles } from "./../constants";

import addTpl from "app/common/create.modal.tpl.html";
import editDetailTpl from "./templates/edit.modal.html";
import cloneOrderTpl from "./templates/clone.order.html";
import createTicketTpl from "./templates/create.ticket.html";
import sendEstimationFormTpl from "./templates/send.estimation.form.html";

import { PrinterListModalCtrl } from "app/printers/ctrls";
import printModalTpl from "app/printers/modal.list.html";

import { DISABLED_DELIVERY_RANGE } from "./constants";
import { DetailViewMap, EditViewMap } from "../helpers";

class AddOrderCtrl extends BaseAddModal {
  constructor($uibModalInstance, store, UserService) {
    "ngInject";
    super($uibModalInstance, store, UserService);
  }

  get title() {
    return `Add Order`;
  }
}

class CloneOrderCtrl {
  constructor($state, $uibModalInstance, order) {
    "ngInject";
    this.data = {
      customer: order.customer,
      company: order.company,
    };
    this.order = order;
    this.$modal = $uibModalInstance;
    this.$state = $state;
  }

  get title() {
    return `Copy order`;
  }

  close() {
    this.$modal.dismiss();
  }

  submit() {
    let self = this;
    self.loading = true;
    let copyNotes = false;
    const copyNotesCheck = document.getElementById("copy-notes");
    if (copyNotesCheck) {
      copyNotes = copyNotesCheck.checked;
    }

    self.order
      .one("clone")
      .customPOST({
        customer: self.data.customer,
        company: self.data.company,
        copy_notes: copyNotes,
      })
      .then(
        (data) => {
          self.$modal.close(data);
        },
        (resp) => {
          self.errors = resp.data;
        },
      )
      .finally(() => (self.loading = false));
  }
}

class OrderRecalc extends BaseReCalc {
  constructor(order, nutrientsReCalc) {
    super(order);

    this.nutrientsReCalc = nutrientsReCalc;
  }
  _nutrients() {
    this.nutrientsReCalc.calcLbs();
  }

  rate() {
    if (!this.canUpdateRate) {
      return;
    }
    this.object.acres = _.round(this.object.acres, 3);

    let quantity = this.object.acres * this.object.rate;

    if (!this.object.water_gallons) {
      quantity = quantity / 2000;
    }
    this.object.quantity = _.round(quantity, 3);
    this._nutrients();
  }
}

class NutrientReCalc {
  constructor(order) {
    this.object = order;
    this.init();
  }

  init() {
    this.nutrients = _.filter(this.object.nutrients, (obj, key) => {
      return (
        ["urea_dry", "an", "crn", "potcarb", "p2", "p3", "s2"].indexOf(key) ===
        -1
      );
    });
    this.nutrients = _.orderBy(_.values(this.nutrients), "ui_place");
    this.nutrients = _.map(this.nutrients, (obj) => {
      obj.label = _.toLower(obj.short_name);
      return obj;
    });
  }

  calcLbs() {
    let self = this;
    for (let obj of self.nutrients) {
      self.onPercentChanged(obj);
    }
  }

  onPercentChanged(obj) {
    if (!obj.percent) {
      obj.percent = 0;
    }
    obj.percent = parseFloat(obj.percent);
    if (obj.percent < 0 || obj.percent > 100) {
      obj.percent = 0;
    }
    obj.percent = _.round(obj.percent, 3);
    obj.lbs = this.object.rate * (obj.percent / 100);
    obj.lbs = _.round(obj.lbs, 3);
  }

  onLbsChanged(obj) {
    if (!obj.lbs) {
      obj.lbs = 0;
    }
    obj.lbs = parseFloat(obj.lbs);
    if (obj.lbs < 0) {
      obj.lbs = 0;
    }
    obj.percent = (obj.lbs / this.object.rate) * 100;
    obj.percent = _.round(obj.percent, 3);
  }
}

class CreateTicket {
  constructor($state, $uibModalInstance, order) {
    "ngInject";
    this.data = {
      tonnage: 0,
      acres: 0,
      fields: angular.copy(order.fields),
      applicators: Array(),
      haulers: Array(),
    };
    this.order = order;
    this.$modal = $uibModalInstance;
    this.$state = $state;
    this.ticketsCreated = [];
    this.data.tonnage = this.tonnage_left;
    this.data.acres = this.acres_left;
  }

  get title() {
    return `Create Ticket`;
  }

  get tonnage_left() {
    return _.max([
      _.round(this.order.tonnage - this.order.tickets_tonnage, 3),
      0,
    ]);
  }

  get acres_left() {
    return _.max([_.round(this.order.acres - this.order.tickets_acres, 3), 0]);
  }

  reCalculateAcres() {
    if (this.touched) {
      return;
    }
    this.data.acres = _.sum(_.map(this.data.fields, "field.acres"));
    this.calculateTonnage();
  }

  calculateAcres() {
    this.data.acres = _.round((this.data.tonnage * 2000) / this.order.rate, 3);
  }

  calculateTonnage() {
    this.data.tonnage = _.round((this.data.acres * this.order.rate) / 2000, 3);
  }

  close() {
    this.$modal.dismiss();
  }

  checkApplicators() {
    let self = this;
    if (self.data.applicators == null) {
      self.data.applicators = [];
    } else if (!Array.isArray(self.data.applicators)) {
      self.data.applicators = Array(self.data.applicators);
    }
    if (self.data.haulers == null) {
      self.data.haulers = [];
    } else if (!Array.isArray(self.data.haulers)) {
      self.data.haulers = Array(self.data.haulers);
    }
  }

  submit(redirect = false) {
    let self = this;
    self.loading = true;
    self.checkApplicators();
    let p = self.order.one("ticket").customPOST(self.data);
    p.then(
      (data) => {
        if (redirect) {
          self.$modal.close(data);
        } else {
          let p2 = self.order
            .customGET("")
            .then((data) => _.extend(self.order, data));
          p2 = p2.then(() => self.ticketsCreated.push(data));
          p2.then(() => (self.loading = false));
          this.data.tonnage = _.max([
            _.round(this.tonnage_left - this.data.tonnage, 3),
            0,
          ]);
          this.data.acres = _.max([
            _.round(this.acres_left - this.data.acres, 3),
            0,
          ]);
        }
      },
      (resp) => {
        self.errors = resp.data;
        self.loading = false;
      },
    );
  }
}

export class ListCtrl {
  constructor($growl, $state, Modal, OrderStore) {
    "ngInject";
    this.$growl = $growl;
    this.$state = $state;
    this.Modal = Modal;
    this.store = OrderStore;
  }

  openAddModal() {
    let self = this;
    let $modal = this.Modal.open({
      template: addTpl,
      controller: AddOrderCtrl,
      size: "small",
      resolve: {
        store: () => this.store,
      },
    });

    $modal.result.then(function (data) {
      self.$growl.added();
      self.$state.go(
        "r.in.top.orders.detail",
        { orderId: data.id, created: true },
        { absolute: true, reload: true },
      );
    });
  }
}

export class DetailsCtrl {
  constructor(
    $scope,
    $window,
    $state,
    $order,
    $growl,
    $httpParamSerializer,
    Modal,
    SecureUrlService,
    UserService,
  ) {
    "ngInject";
    this.order = $order;
    this.$state = $state;
    this.$growl = $growl;
    this.$window = $window;
    this.user = UserService.$user;
    this.$httpParamSerializer = $httpParamSerializer;
    this.Modal = Modal;
    this.secureUrlService = SecureUrlService;
    this.loading = {};

    // Assign to the scope and pass value to child views
    $scope.canViewEditButton = this.canViewEditButton;
  }

  get canViewEditButton() {
    // Edit button should be always visible, but it should not be visible
    // in few cases like:
    if (this.user.role && this.user.role.id === roles.SALESPERSON) {
      // if ticket is created from the order, salesperson cannot edit
      return this.order.tickets.length === 0;
    }
    if (this.user.role && this.user.role.id === roles.DISPATCHER) {
      // disable for dispatcher
      return false;
    }

    return true;
  }

  get canSeePrice() {
    if (
      this.user.role &&
      [roles.PLANT_MANAGER, roles.DISPATCHER].includes(this.user.role.id)
    ) {
      // hide for plant_manager & dispatcher
      return false;
    }

    return true;
  }

  createTicket() {
    let self = this;
    let $modal = this.Modal.open({
      template: createTicketTpl,
      controller: CreateTicket,
      size: "small",
      resolve: {
        order: () => this.order,
      },
    });

    $modal.result.then(function (data) {
      self.$state.go("r.in.top.tickets.detail", {
        ticketId: data.id,
        created: true,
      });
      self.$growl.added();
    });
  }

  cloneOrder() {
    let self = this;
    let $modal = this.Modal.open({
      template: cloneOrderTpl,
      controller: CloneOrderCtrl,
      size: "small",
      resolve: {
        order: () => this.order,
      },
    });

    $modal.result.then(function (data) {
      self.$state.go("r.in.top.orders.detail", { orderId: data.id });
      self.$growl.success("Copied successfully !");
    });
  }

  openSendEmail(type) {
    let controller = SendEstimatePDFCtrl;
    if (type === "form") {
      controller = SendFormPDFCtrl;
    } else if (type == "send_and_print") {
      controller = SendAndPrintFormCtrl;
    }

    let self = this;
    let $modal = this.Modal.open({
      template: sendEstimationFormTpl,
      controller: controller,
      size: "large",
      resolve: {
        order: () => self.order,
      },
    });

    $modal.result.then(function () {
      self.$growl.success("E-mail has been sent");
    });
  }

  print(type) {
    let endpoint =
      type === "estimate"
        ? this.order.all("estimate").all("print")
        : this.order.all("form").all("print");
    let self = this;
    let $modal = this.Modal.open({
      template: printModalTpl,
      controller: PrinterListModalCtrl,
      size: "large",
      resolve: {
        company: () => self.order.company.id,
        request: () => {
          return {
            endpoint: endpoint,
            multiple: false,
          };
        },
      },
    });

    $modal.result.then(function () {
      self.$growl.success("Added file to queue");
    });
  }

  orderFormUrl() {
    this.secureUrlService.openInNewWindow(this.order.one("form"));
  }

  orderEstimateUrl() {
    this.secureUrlService.openInNewWindow(this.order.one("estimate"));
  }

  sendAndPrint() {
    let self = this;
    self.loading["sendAndPrint"] = true;
    this.order
      .all("print-and-send")
      .post()
      .then(() => {
        self.$growl.success("Sent email and added file to print queue");
      })
      .finally(() => {
        self.loading["sendAndPrint"] = false;
      });
  }
}

export class OrderDetailsCtrl extends DetailViewMap {
  constructor(
    $order,
    $growl,
    $stateParams,
    UserService,
    ApplicatorConfigStore,
    CompanyFreightStore,
    NutrientPricesStore,
    Modal,
    FieldStore,
    hotkeys,
    modalRegistry,
  ) {
    "ngInject";
    super($order); //maps
    this.$growl = $growl;
    this.$stateParams = $stateParams;
    this.order = $order;
    this.Modal = Modal;
    this.user = UserService.$user;
    this.hotkeys = hotkeys;
    this.modalRegistry = modalRegistry;
    this.applicatorsConfig = ApplicatorConfigStore;
    this.companyFreightStore = CompanyFreightStore;
    this.nutrientPricesStore = NutrientPricesStore;
    this.nutrientReCalc = new NutrientReCalc(this.order);
    this.priceCalc = new PriceCalculation(
      this.order,
      this.applicatorsConfig,
      this.companyFreightStore,
      this.nutrientPricesStore,
    );
    this.fieldStore = FieldStore;
    this.i = 0;

    this.setHotKeys();
    this.customEvents();
  }

  customEvents() {
    if (this.$stateParams.created) {
      this.editModal();
    }
  }

  setHotKeys() {
    let self = this;
    if (this.user.role.name != "Dispatcher") {
      self.hotkeys.add({
        combo: "e",
        description: "Edit Modal",
        callback: function (event, hotkey) {
          if (self.modalRegistry.isOpen("order-edit")) {
            return;
          }
          self.modalRegistry.push("order-edit");
          self.editModal();
        },
      });
    }
  }

  onProductsChange() {
    this.priceCalc.preview();
  }

  editModal() {
    let self = this;
    let $modal = this.Modal.open({
      template: editDetailTpl,
      controller: EditOrderDetailsCtrl,
      size: "ticket-edit",
      resolve: {
        order: () => this.order,
      },
    });

    $modal.result
      .then(function () {
        if (self.$stateParams.created) {
          // reload page if crated
          window.location.reload();
        } else {
          // Update components
          self.nutrientReCalc = new NutrientReCalc(self.order);
          self.priceCalc.preview();
          self.$growl.updated();
          self.getStaticLocations();
          self.updateMarkers();
        }
      })
      .finally(() => {
        self.modalRegistry.pop("order-edit");
      });
  }
}

class BaseSendPDFFrom {
  constructor($uibModalInstance, UserService, order, R) {
    "ngInject";
    this.$modal = $uibModalInstance;
    this.user = UserService.$user;
    this.multipleOrders = false;
    this.R = R;
    if (Array.isArray(order)) {
      if (order.length > 1) {
        this.multipleOrders = true;
        this.orders = order;
      } else {
        this.order = order[0];
      }
    } else {
      this.order = order;
    }
    this.data = this.buildContext();
  }

  get title() {
    throw "title() not implemented";
  }

  buildContext() {
    throw "buildContext() not implemented";
  }

  close() {
    this.$modal.dismiss();
  }
}

export class SendEstimatePDFCtrl extends BaseSendPDFFrom {
  constructor($uibModalInstance, UserService, order, R) {
    "ngInject";
    super($uibModalInstance, UserService, order, R);
  }

  get title() {
    return `Estimate Email`;
  }

  buildContext() {
    if (this.multipleOrders) {
      let customers = new Array();
      let emails = new Set(_.map(this.user.email_to, "email"));
      this.orders.forEach((value) => {
        customers.push(`${value.id} of customer ${value.customer.title}`);
        emails.add(value.company.email);
      });
      return {
        subject: `Willard Agri Service Estimate for multiple orders.`,
        message: `Hello, \nAttached is an estimate of orders: \n${_.join(customers, ", \n")}.`,
        email_to: _.join(Array.from(emails), ",") || "",
        bcc_salesperson: true,
      };
    } else {
      let emailTo = _.map(this.user.email_to, "email");
      if (emailTo.indexOf(this.order.company.email) === -1) {
        emailTo.push(this.order.company.email);
      }
      return {
        subject: `Willard Agri Service Estimate for ${this.order.customer.title}`,
        message: `Hello, \nAttached is an estimate of your order.`,
        email_to: _.join(emailTo, ",") || "",
        bcc_salesperson: true,
      };
    }
  }

  submit() {
    let self = this;
    self.loading = true;
    if (this.multipleOrders) {
      self.data["orders"] = self.orders.map((value) => value.id);
      self.R.all(["orders", "estimate", "send"].join("/"))
        .post(self.data)
        .then(
          () => {
            self.$modal.close(true);
          },
          (resp) => {
            self.errors = resp.data;
          },
        )
        .finally(() => {
          self.loading = false;
        });
    } else {
      self.order
        .one("estimate")
        .post("send", self.data)
        .then(
          () => {
            self.$modal.close(true);
          },
          (resp) => {
            self.errors = resp.data;
          },
        )
        .finally(() => {
          self.loading = false;
        });
    }
  }
}

export class SendFormPDFCtrl extends BaseSendPDFFrom {
  constructor($uibModalInstance, UserService, order, R) {
    "ngInject";
    super($uibModalInstance, UserService, order, R);
  }

  get title() {
    return `Form Email`;
  }

  buildContext() {
    if (this.multipleOrders) {
      let customers = new Array();
      let emails = new Set(_.map(this.user.email_to, "email"));
      this.orders.forEach((value) => {
        customers.push(`${value.id} of customer ${value.customer.title}`);
        emails.add(value.company.email);
      });
      return {
        subject: `Order Form for multiple orders`,
        message: `Hello, \nAttached is the Order Form for orders: \n${_.join(Array.from(customers), ", \n")}.`,
        email_to: _.join(Array.from(emails), ",") || "",
        bcc_salesperson: true,
      };
    } else {
      let emailTo = _.map(this.user.email_to, "email");
      if (emailTo.indexOf(this.order.company.email) === -1) {
        emailTo.push(this.order.company.email);
      }
      return {
        subject: `Order Form for ${this.order.customer.title}`,
        message: `Hello, \nAttached is the Order Form.`,
        email_to: _.join(emailTo, ",") || "",
        bcc_salesperson: true,
      };
    }
  }

  submit() {
    let self = this;
    self.loading = true;
    if (this.multipleOrders) {
      self.data["orders"] = self.orders.map((value) => value.id);
      self.R.all(["orders", "form", "send"].join("/"))
        .post(self.data)
        .then(
          () => {
            self.$modal.close(true);
          },
          (resp) => {
            self.errors = resp.data;
          },
        )
        .finally(() => {
          self.loading = false;
        });
    } else {
      self.order
        .one("form")
        .post("send", self.data)
        .then(
          () => {
            self.$modal.close(true);
          },
          (resp) => {
            self.errors = resp.data;
          },
        )
        .finally(() => {
          self.loading = false;
        });
    }
  }
}

export class SendAndPrintFormCtrl extends SendFormPDFCtrl {
  constructor($uibModalInstance, UserService, order, $growl, R) {
    "ngInject";
    super($uibModalInstance, UserService, order, R);
    this.$growl = $growl;
    this.btnLabel = "Send and Print";
  }

  get title() {
    return `Send and Print Form`;
  }

  submit() {
    let self = this;
    self.loading = true;
    if (this.multipleOrders) {
      self.data["orders"] = self.orders.map((value) => value.id);
      self.R.all(["orders", "print-and-send"].join("/"))
        .post(self.data)
        .then(
          () => {
            self.$modal.close(true);
          },
          (resp) => {
            self.errors = resp.data;
          },
        )
        .finally(() => {
          self.loading = false;
        });
    } else {
      self.order
        .post("print-and-send", self.data)
        .then(
          () => {
            self.$modal.close(true);
          },
          (resp) => {
            self.errors = resp.data;
            if (resp.data.non_field_errors) {
              self.$growl.error(resp.data.non_field_errors[0]);
            }
          },
        )
        .finally(() => {
          self.loading = false;
        });
    }
  }
}

export class EditOrderDetailsCtrl extends EditViewMap {
  constructor(
    ApplicatorStore,
    $growl,
    ApplicatorConfigStore,
    Config,
    CompanyFreightStore,
    NutrientPricesStore,
    CustomerStore,
    R,
    Modal,
    $uibModalInstance,
    order,
    ProductStore,
  ) {
    "ngInject";
    super(order); // maps
    this.R = R;
    this.$growl = $growl;
    this.customers = CustomerStore;
    this.applicators = ApplicatorStore;
    this.applicatorsConfig = ApplicatorConfigStore;
    this.companyFreightStore = CompanyFreightStore;
    this.nutrientPricesStore = NutrientPricesStore;
    this.productStore = ProductStore;
    this.config = Config;
    this.order = order;
    this.data = this.R.copy(this.order);
    this.nutrientReCalc = new NutrientReCalc(this.data);
    this.tRecalc = new OrderRecalc(this.data, this.nutrientReCalc);
    this.priceCalc = new PriceCalculation(
      this.data,
      this.applicatorsConfig,
      this.companyFreightStore,
      this.nutrientPricesStore,
    );
    this.priceCalc.calc();

    this.showPrices = false;
    this.saveDisabled = false;
    this.convertToPints = this.data.quantity_units === "GALS";

    this.$modal = $uibModalInstance;
    this.Modal = Modal;
    this.units = [
      {
        id: "TONS",
        name: "T",
      },
      {
        id: "GALS",
        name: "G",
      },
    ];
    this.acresStatus = "";
  }

  get isZoneEditable() {
    return this.order.company.id === MARION_ID;
  }

  acresStatusCallback() {
    this.acresStatus = "";
  }

  onProductUpdate(recalcOnlyChemicals) {
    let shouldDisable = false;

    if (this.data.products.length >= 1) {
      _.forEach(this.data.products, (obj) => {
        if (
          _.inRange(
            obj.product && obj.product.id,
            DISABLED_DELIVERY_RANGE[0],
            DISABLED_DELIVERY_RANGE[1],
          )
        ) {
          shouldDisable = true;
          return;
        }
      });

      if (shouldDisable) {
        this.priceCalc.disableCalcForDelivery();
      } else {
        this.priceCalc.enableCalcForDelivery();
      }
    } else {
      this.priceCalc.enableCalcForDelivery();
    }
    this.priceCalc.calc(recalcOnlyChemicals);
  }

  recalculatePrice(recalcOnlyChemicals) {
    this.priceCalc.calc(recalcOnlyChemicals);
  }

  onAcresModelChange() {
    this.tRecalc.acres();
    this.priceCalc.calc();
    this.data.is_acres_touched = true;
  }

  onQuantityChange() {
    this.tRecalc.quantity();
    this.priceCalc.calc();
    this.data.is_acres_touched = true;
  }

  reCalculateAcres(canReCalc) {
    if (canReCalc) {
      return;
    }

    // If empty do nothing
    if (!_.isArray(this.data.fields)) {
      return;
    }

    this.data.acres = _.round(_.sum(_.map(this.data.fields, "field.acres")), 3);
    this.tRecalc.acres();
  }

  onAcresTouchChange(isChanged) {
    this.reCalculateAcres(isChanged);
  }

  onAcresChange() {
    if (this.data.is_acres_touched) {
      this.acresStatus = "not-updated";
    } else {
      this.acresStatus = "updated";
    }
    this.getDynamicLocations(this.data.fields);
    this.updateMarkers();
    this.reCalculateAcres(this.data.is_acres_touched);
  }

  onWaterChange() {
    let quantity = parseFloat(this.data.quantity) || 0;
    this.data.quantity = _.round(
      this.data.water_gallons ? quantity * 2000 : quantity / 2000,
      2,
    );
    this.data.quantity_units = this.data.water_gallons ? "GALS" : "TONS";
  }

  onDeliveryChange() {
    this.priceCalc.calc();
  }

  get title() {
    return `Order #${this.data.id} - ${this.data.customer.title}`;
  }

  close() {
    this.$modal.dismiss();
  }

  submit() {
    let self = this;
    if (self._submitting) {
      return;
    }
    self._submitting = true;
    let data = self.R.copy(self.data);
    data.products = _.filter(data.products, (o) => {
      return o.product;
    }); // to avoid glitches
    data.custom_fields_destinations = self.order.custom_fields_destinations;

    data
      .put()
      .then(
        (response) => {
          angular.extend(self.order, response);
          self.$modal.close(response);
        },
        (resp) => {
          if (resp.status === 403) {
            self.$growl.error(resp.data.detail);
          } else {
            Object.entries(resp.data).forEach((entry) => {
              const [field, error] = entry;
              error.forEach((err_msg) => {
                if (typeof err_msg === "object" && err_msg !== null) {
                  Object.entries(err_msg).forEach((list_entry) => {
                    self.$growl.error(`${field}: ${list_entry}`);
                  });
                } else {
                  self.$growl.error(`${field}: ${err_msg}`);
                }
              });
            });
          }
          self.errors = resp.data;
        },
      )
      .finally(() => {
        self.loading = false;
        self._submitting = false;
      });
  }
}

export class FilesCtrl {
  constructor($order) {
    "ngInject";
    this.order = $order;
  }
}

export class NotesCtrl extends BaseNotesCtrl {
  constructor(R, $order, $growl) {
    "ngInject";
    super(R, $growl, $order);
  }
}

export class LogCtrl {
  constructor() {}
}

class PriceCalculation {
  constructor(
    data,
    applicatorsConfig,
    companyFreightStore,
    nutrientPricesStore,
  ) {
    this.data = data;
    this.haulerCost = 0.0;
    this.fertTotalCost = 0.0;
    this.totalProductsCost = 0.0;
    this.enabledCalcForDelivery = true;

    this.isCalculating = false;

    this.applicatorsConfig = applicatorsConfig;
    this.companyFreightStore = companyFreightStore;
    this.nutrientPricesStore = nutrientPricesStore;

    this.nutrientKeys = ["n", "k", "b", "z", "cu", "mn", "fe"];

    this.nutrientsForSpecialPricing = _.clone(this.nutrientKeys);
    this.nutrientsForSpecialPricing.push("p");
    this.nutrientsForSpecialPricing.push("sulfur_dry");
    this.initialize();
  }

  initialize() {
    this.applicatorsConfig.init();
    this.companyFreightStore.init();
    this.nutrientPricesStore.init();

    this.applicatorsConfig.params.company = this.data.company.id;
    this.companyFreightStore.params.company = this.data.company.id;
    this.nutrientPricesStore.params = {
      company: this.data.company.id,
      price_level: this.data.customer.price_level,
      ns_price_level: this.data.customer.non_standard_price_level,
      customer: this.data.customer.id,
    };

    let self = this;
    this.applicatorsConfig.refresh().then(function () {
      self.calcApplicatorCost();
    });
    this.companyFreightStore.refresh().then(function () {
      self.calcApplicatorCost();
    });
  }

  calc(calcOnlyChemicals) {
    if (calcOnlyChemicals) {
      this.calcProductsTotalCost();
    }
    this.calcApplicatorCost();
    this.calcTotalCost();
  }

  preview() {
    let self = this;
    let nutrientsTotalCost = 0;

    if (this.data.fertilizer_special_price) {
      nutrientsTotalCost =
        self.data.fertilizer_special_price * self.data.quantity;
    } else {
      nutrientsTotalCost = _.sum(
        _.map(self.nutrientKeys, function (key) {
          return self.nutrient_total_price(
            self.data.nutrients[key].price,
            self.data.nutrients[key].lbs,
          );
        }),
      );
    }

    self.fertTotalCost = self.calcFertTotalCost(
      nutrientsTotalCost,
      self.data.applicator_price,
    );

    self.calcProductsTotalCost();
  }

  price_per_lbs(price) {
    return price / 20;
  }

  nutrient_total_price(nutrientPrice, nutrientLbs) {
    return _.round(
      this.price_per_lbs(nutrientPrice) * nutrientLbs * this.data.acres,
      2,
    );
  }

  calcPFactor(lbs, price) {
    const p_percentage_points =
      100 - (this.data.base + this.data.nutrients.p3.percent);
    return this.calcPXFactor(lbs, price, p_percentage_points);
  }

  calcPXFactor(lbs, price, percentage_points) {
    return _.round(
      (lbs * this.price_per_lbs(price) * this.data.acres * percentage_points) /
        100,
      2,
    );
  }

  calcSFactor(lbs, price) {
    const p_percentage_points = 100 - this.data.nutrients.s2.percent;
    return this.calcPXFactor(lbs, price, p_percentage_points);
  }

  calcSXFactor(lbs, price, percentage_points) {
    return _.round(
      (lbs * this.price_per_lbs(price) * this.data.acres * percentage_points) /
        100,
      2,
    );
  }

  disableCalcForDelivery() {
    this.enabledCalcForDelivery = false;
  }

  enableCalcForDelivery() {
    this.enabledCalcForDelivery = true;
  }

  calcApplicatorCostDefault() {
    let self = this;
    let freightZone = parseInt(self.data.freight_zone);
    let freightZoneObj = _.find(this.companyFreightStore.list, function (obj) {
      return obj.zone === freightZone;
    });
    let applicationObj = _.find(this.applicatorsConfig.list, function (obj) {
      return obj.zone === 1 && obj.range === 1;
    });

    let freightZoneRate = (freightZoneObj && freightZoneObj.rate) || 0.0;
    let applicationRate = (applicationObj && applicationObj.rate) || 0.0;

    let freightCost = freightZoneRate; // Rate per ton
    let applicationCost =
      (self.data.acres * applicationRate) / self.data.quantity; // Appl rate per ton

    this.setApplicatorCost(freightCost, applicationCost);
  }

  calcApplicatorCost() {
    if (!this.enabledCalcForDelivery) {
      this.setApplicatorCost(0, 0);
      return;
    }
    this.calcApplicatorCostDefault();
  }

  setApplicatorCost(freightZoneRate, applicationRate) {
    switch (this.data.delivery) {
      case "apply_haul":
        this.haulerCost = _.round(freightZoneRate + applicationRate, 3);
        break;
      case "haul":
        this.haulerCost = _.round(freightZoneRate, 3);
        break;
      default:
        this.haulerCost = 0;
        break;
    }
  }

  calcFertTotalCost(nutrientsTotalCost, applHaulCost) {
    let pCost = this.calcPFactor(
      this.data.nutrients.p.lbs,
      this.data.nutrients.p.price,
    );
    let p2Cost = this.calcPXFactor(
      this.data.nutrients.p.lbs,
      this.data.nutrients.p2.price,
      this.data.base,
    );
    let p3Cost = this.calcPXFactor(
      this.data.nutrients.p.lbs,
      this.data.nutrients.p3.price,
      this.data.nutrients.p3.percent,
    );

    let sCost = this.calcSFactor(
      this.data.nutrients.sulfur_dry.lbs,
      this.data.nutrients.sulfur_dry.price,
    );
    let s2Cost = this.calcSXFactor(
      this.data.nutrients.sulfur_dry.lbs,
      this.data.nutrients.s2.price,
      this.data.nutrients.s2.percent,
    );

    let totalCost = 0;
    if (this.data.rate !== 0) {
      let acresRate = this.data.acres / (2000 / this.data.rate);
      totalCost =
        nutrientsTotalCost +
        pCost +
        p2Cost +
        p3Cost +
        sCost +
        s2Cost +
        acresRate * applHaulCost;
    }

    // Store information about p and p2 cost
    if (this.data.nutrients) {
      this.data.nutrients["p"]["total_price"] = pCost || 0;
      this.data.nutrients["p2"]["total_price"] = p2Cost || 0;
      this.data.nutrients["p3"]["total_price"] = p3Cost || 0;

      this.data.nutrients["sulfur_dry"]["total_price"] = sCost || 0;
      this.data.nutrients["s2"]["total_price"] = s2Cost || 0;
    }

    if (_.isNaN(totalCost)) {
      return 0;
    }
    return totalCost;
  }

  setZeroPriceForAllNutrients() {
    let self = this;
    _.each(self.nutrientKeys, function (key) {
      self.data.nutrients[key]["price"] = 0;
    });
    self.data.nutrients["p"]["price"] = 0;
    self.data.nutrients["p2"]["price"] = 0;
    self.data.nutrients["p3"]["price"] = 0;

    this.data.nutrients["sulfur_dry"]["total_price"] = 0;
    this.data.nutrients["s2"]["total_price"] = 0;
  }

  getCurrentNutrientsValue() {
    let self = this;
    return _.fromPairs(
      _.map(self.nutrientsForSpecialPricing, function (key) {
        return [key, self.data.nutrients[key].percent];
      }),
    );
  }

  calcTotalCost() {
    let self = this;

    this.isCalculating = true;

    if (this.data.crop && this.data.crop.id) {
      this.nutrientPricesStore.params.crop = this.data.crop.id;
    }

    // Gen current nutrients values
    let nutrientValues = self.getCurrentNutrientsValue();
    _.extend(this.nutrientPricesStore.params, nutrientValues);

    this.nutrientPricesStore
      .refresh()
      .then(function (obj) {
        let nutrientsTotalCost = 0;
        let nutrientPrices = obj.list;

        if (_.has(nutrientPrices, "special_total_price")) {
          nutrientsTotalCost =
            nutrientPrices.special_total_price * self.data.quantity;
          self.data.fertilizer_special_price =
            nutrientPrices.special_total_price;
          self.setZeroPriceForAllNutrients();
        } else {
          nutrientPrices = obj.list.nutrients;
          self.data.price_level = _.toString(obj.list.price_level);
          self.data.fertilizer_special_price = null;
          nutrientsTotalCost = _.sum(
            _.map(self.nutrientKeys, function (key) {
              let totalPrice = self.nutrient_total_price(
                nutrientPrices[key],
                self.data.nutrients[key].lbs,
              );
              self.data.nutrients[key]["price"] = nutrientPrices[key] || 0;
              self.data.nutrients[key]["total_price"] = totalPrice;
              return totalPrice;
            }),
          );

          // Saving to database
          self.data.nutrients["p"]["price"] = nutrientPrices.p || 0;
          self.data.nutrients["p2"]["price"] = nutrientPrices.p2 || 0;
          self.data.nutrients["p3"]["price"] = nutrientPrices.p3 || 0;

          self.data.nutrients["sulfur_dry"]["price"] =
            nutrientPrices.sulfur_dry || 0;
          self.data.nutrients["s2"]["price"] = nutrientPrices.s2 || 0;
        }

        self.data.applicator_price = self.haulerCost;
        self.fertTotalCost = self.calcFertTotalCost(
          nutrientsTotalCost,
          self.haulerCost,
        );
      })
      .finally(function () {
        self.isCalculating = false;
        self.calcProductsTotalCost();
      });
  }

  calcProductsTotalCost() {
    this.totalProductsCost = _.sum(
      _.map(this.data.products, function (obj) {
        return obj.total_price || 0.0;
      }),
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/orders/ctrls.js